/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The number of questions still waiting for an answer.
 * @export
 * @interface EventQuestionSummary
 */
export interface EventQuestionSummary {
    /**
     * 
     * @type {number}
     * @memberof EventQuestionSummary
     */
    open: number;
}

/**
 * Check if a given object implements the EventQuestionSummary interface.
 */
export function instanceOfEventQuestionSummary(value: object): value is EventQuestionSummary {
    if (!('open' in value) || value['open'] === undefined) return false;
    return true;
}

export function EventQuestionSummaryFromJSON(json: any): EventQuestionSummary {
    return EventQuestionSummaryFromJSONTyped(json, false);
}

export function EventQuestionSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'open': json['open'],
    };
}

export function EventQuestionSummaryToJSON(json: any): EventQuestionSummary {
    return EventQuestionSummaryToJSONTyped(json, false);
}

export function EventQuestionSummaryToJSONTyped(value?: EventQuestionSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'open': value['open'],
    };
}

